import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Button } from '~/shadcn/ui/button/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '~/shadcn/ui/dialog'

type Props = { onClose(): void }

/**
 * Veriff schválil identitu, ale user nemá 18 rokov (BE `identity.isUnderage`).
 * Zobrazuje sa po návrate z Veriffu a pri každom pokuse o „Overiť identitu“, kým user
 * nedovŕši 18 — BE flag sa vtedy prepne sám a onboarding pokračuje bez nového Veriffu.
 */
function IdentityVerificationUnderageDialog({ onClose }: Props) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className="flex flex-col gap-8 py-8 md:p-8">
          <DialogTitle asChild>
            <HeadingTwo>Na investovanie musíte mať aspoň 18 rokov</HeadingTwo>
          </DialogTitle>
          <DialogDescription asChild>
            <p className=" !text-foreground">
              Ďakujeme za Váš záujem. Investovať na platforme môžu podľa zákona
              iba <strong>osoby staršie ako 18 rokov</strong>, preto Vašu
              registráciu teraz nedokážeme dokončiť. Budeme radi, keď sa k nám
              vrátite po dovŕšení 18 rokov. Radi Vás uvítame a prevedieme Vás
              prvými krokmi.
            </p>
          </DialogDescription>
          <Button
            variant="accent"
            className="w-full"
            size="3xl"
            onClick={onClose}>
            Rozumiem
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { IdentityVerificationUnderageDialog }
